import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle } from '@mui/icons-material';
import { useSnackbarContext } from '@ui-lib/components/Snackbar/SnackbarProvider';
import Button from '@ui-lib/components/Button';
import ConfirmationModal from '@ui-lib/components/ModalWindow/ConfirmationModal';
import { useModal } from '@web-shared/hooks';
import useManualRequest from '@web-shared/hooks/useManualRequest';
import HttpError from '@web-shared/services/http-service/HttpError';
import { updateEbol } from '../../../../../api';
import { EBOL_STATUS } from '../../../../../api/types/EbolStatus';
import { useBolAuthToken } from '../../BolDetails/components/DeliveryTokenContext';
import { EbolActionProps } from './EbolActionModal/types';

const AcceptButton = ({ ebolDetails, onStatusChange }: EbolActionProps) => {
  const { t } = useTranslation();
  const [open, handleModal] = useModal();

  const { loading, trigger } = useManualRequest(updateEbol);
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();
  const token = useBolAuthToken();

  const onAccept = async () => {
    try {
      const details = await trigger({ id: ebolDetails.id, status: EBOL_STATUS.ACCEPTED, token: token! });
      showSuccessSnackbar({ message: t('message_shipmentAcceptedSuccessfully') });
      onStatusChange({
        ...details,
        photos: ebolDetails.photos,
      });
    } catch (err) {
      const message = HttpError.isHttpError(err) ? err.message : t('message_failedToAcceptShipment');
      showErrorSnackbar({ message });
    }
    handleModal();
  };

  return <>
    <Button
      color="primary"
      startIcon={<CheckCircle />}
      onClick={handleModal}
      fullWidth
    >
      {t('label_accept')}
    </Button>
    <ConfirmationModal
      open={open}
      onClose={handleModal}
      onSubmit={onAccept}
      title={t('label_confirmAcceptShipment', { ref: ebolDetails.reference_number })}
      subTitle={t('label_undoneAction')}
      submitBtnLabel={t('Ok')}
      loading={loading}
      modalType={'success'}
    />
  </>;
};

export default AcceptButton;